<template>
  <div class="flex p-1.5 rounded-full bg-grey-light-50 border border-grey-light-200 w-fit mx-auto">
    <div
      v-for="product in products"
      :key="product.name"
      @click="onSelectProduct(product.name)"
      :class="[
        'flex items-center justify-center rounded-full h-[47px] px-6 hover:cursor-pointer',
        themeStore.current === product.name ? 'bg-primary custom-shadow' : '',
      ]"
    >
      <img
        :class="product.logoClass"
        :src="themeStore.current === product.name ? product.logoWhite : product.logoGrey"
        :alt="product.alt"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import boostGrey from '@/assets/images/boost-logo-grey.svg';
import boostWhite from '@/assets/images/boost-logo-white.svg';
import laybyGrey from '@/assets/images/layby-logo-grey.svg';
import laybyWhite from '@/assets/images/layby-logo-white.svg';
import plansWhite from '@/assets/images/plans-logo-white.svg';
import plansGrey from '@/assets/images/plans-logo-grey.svg';
import { useThemeStore } from '@/stores/theme';
import { useRouter } from 'vue-router';

const themeStore = useThemeStore();
const router = useRouter();

const products: { name: 'layby' | 'plans' | 'boost'; logoWhite: string; logoGrey: string; alt: string; logoClass: string }[] = [
  {
    name: 'layby',
    logoWhite: laybyWhite,
    logoGrey: laybyGrey,
    alt: 'LayBy Logo',
    logoClass: 'w-[97px] h-[37px]',
  },
  {
    name: 'plans',
    logoWhite: plansWhite,
    logoGrey: plansGrey,
    alt: 'Plans Logo',
    logoClass: 'w-[82px] h-[20px]',
  },
  {
    name: 'boost',
    logoWhite: boostWhite,
    logoGrey: boostGrey,
    alt: 'Boost Logo',
    logoClass: 'w-[70px] h-[25px]',
  },
];

const onSelectProduct = (productName: 'layby' | 'plans' | 'boost') => {
  themeStore.setProduct(productName);

  const currentPath = router.currentRoute.value.path;
  const newPath = currentPath.replace(/^\/(layby|plans|boost)/, `/${productName}`);
  router.push(newPath === currentPath ? `/${productName}` : newPath);
};
</script>

<style scoped>
.custom-shadow {
  box-shadow:
    0 1.07px 3.21px rgba(16, 24, 40, 0.1),
    0 1.07px 2.14px rgba(16, 24, 40, 0.06);
}
</style>
